/**
 * CORE-1959 (QA 28.10.2026, dev, Note8 Chrome и iPhone Safari) — экран комнаты,
 * который после входа сменяется свежим экраном ТОЙ ЖЕ комнаты, не уходит из неё.
 *
 * Гость жмёт «Войти» в комнате; экран комнаты остаётся под формой входа и на
 * смену личности сам переходит в участника: `LeaveSpectate` и новый сокет хаба
 * (`Connecting`). Через миг `LoginScreen` возвращает в комнату сбросом стека
 * (`buildRoomReturnRoutes`, CORE-1341): старый экран размонтируется, новый
 * поднимается. Очистка старого видела настоящее размонтирование и отправляла
 * `LeaveParty`, причём ждала ради него свой подключающийся сокет до 6 с
 * (CORE-1588). Замер: `room_hub_leave {LeaveParty, unmounting: true,
 * stateAtTeardown: Connecting}` через 0,6–0,9 с после `LeaveSpectate` и за
 * 13–176 мс до `connected` нового экрана. `LeaveParty` адресован человеку, не
 * сокету: дойди он после `JoinParty` нового экрана — сервер снял бы только что
 * вошедшего.
 *
 * Здесь — пометка «этот экран комнаты сменяется свежим той же комнаты». Её ставит
 * тот, кто сбрасывает стек, ДО сброса, по ключу маршрута (он у каждого экземпляра
 * экрана свой). Очистка хаба забирает её по своему ключу и уходить не шлёт:
 * присутствие держит преемник. Состояние модуля — на вкладку: в одной вкладке
 * один вошедший, так что «тот же человек» здесь следует из «та же вкладка».
 *
 * Срок у пометки короткий: сброс идёт сразу (чанк экрана комнаты уже скачан), а
 * не сработавший сброс не должен навсегда отнять уход у экрана, который остался.
 */
export const ROOM_HANDOFF_TTL_MS = 10_000;

const handoffs = new Map<string, number>();

/** Экраны комнаты с этими ключами маршрутов сейчас сменятся свежими той же комнаты. */
export function markRoomHandoff(routeKeys: readonly string[], now = Date.now()): void {
    for (const key of routeKeys) handoffs.set(key, now);
}

/**
 * Сменяется ли экран комнаты с этим ключом преемником. Пометка забирается: второй
 * раз тот же экран уходить не будет, а ключ маршрута не повторяется.
 */
export function takeRoomHandoff(routeKey: string | null | undefined, now = Date.now()): boolean {
    if (!routeKey) return false;
    const at = handoffs.get(routeKey);
    if (at === undefined) return false;
    handoffs.delete(routeKey);
    return now - at <= ROOM_HANDOFF_TTL_MS;
}

/** Только для тестов. */
export function __resetRoomHandoffsForTests(): void {
    handoffs.clear();
}
